/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t,e,a){e.keys().forEach(t=>{a.set(t,e.get(t),0)});const n=t.metadata;Object.keys(n).forEach(e=>{t.internalGet(e)&&a.set(e,t.internalGet(e),0)})}export{t as setupConstructedDefaults};
